import { VersionService } from 'api/schema'
import type { VersionInfo } from 'api/schema'
import type { IVersionInfo } from 'utils/interfaces'

const normalizeVersionInfo = (dto: VersionInfo): IVersionInfo => ({
  version: dto.version,
  branch: dto.branch ?? null,
  commit: dto.commit ?? null,
  buildTime: dto.build_time ?? null,
  gitAhead: dto.ahead ? dto.ahead.toString() : null,
})

export const VersionApi = {
  fetchVersion: async (): Promise<IVersionInfo> => {
    const dto = await VersionService.versionRetrieve()
    return normalizeVersionInfo(dto)
  },
}
